import React, { useEffect, useState } from 'react';
import './VideoInstruction.css';
import { useNavigate, useParams } from 'react-router-dom';

const VideoInstruction = () => {
  const landscape = `${process.env.PUBLIC_URL}/inspection-icons/landscapeMode.svg`;
  const clock_icon = `${process.env.PUBLIC_URL}/custom-icons/intro.gif`;
  const navigate = useNavigate();
  const { claimNumber } = useParams();
  const [isInLandscapeMode, setIsInLandscapeMode] = useState(
    window.screen.orientation.type
  );

  useEffect(() => {
    const updateOrientation = () => {
      setIsInLandscapeMode(window.screen.orientation.type);
    };

    window.addEventListener("orientationchange", updateOrientation);

    return () => {
      window.removeEventListener("orientationchange", updateOrientation);
    };
  }, [isInLandscapeMode]);

  return (
    <>
      {isInLandscapeMode === "portrait-primary" ||
        isInLandscapeMode === "portrait-secondary" ? (
        <div
          style={{
            // backgroundColor: "#427eea",
            opacity: "0.8",
            height: "100svh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <img
            src={landscape}
            alt="Landscape GIF"
            style={{
              height: "4rem",
              // animation: "tiltDown 1s ease infinite alternate",
            }}
          />
          <h3
            style={{
              // color: "#fff",
              textAlign: "center",
              marginBottom: "0.5rem",
              wordWrap: "break-word",
            }}
          >
            Please rotate video to landscape
          </h3>
          <h6
            style={{
              // color: "#fff",
              padding: "0 1rem",
              textAlign: "center",
              wordWrap: "break-word",
            }}
          >
            Turn on auto-rotation as video needs to be captured in landscape
            mode.
          </h6>
        </div>
      ) : (
        <div className="container vdo-container">
          <div className="instructions">
            
            
            <div className="instructions-wrapper">
              <div className="instructions-column">
                <ul className="stepVdo-list">
                  <h2 className="title">Video instruction</h2>
                  <li className="stepVdo">
                    <div className="stepVdo-number">1</div>
                    <p className="stepVdo-text">
                      Turn off the vehicle (if it's on)
                    </p>
                  </li>
                  <li className="stepVdo">
                    <div className="stepVdo-number">2</div>
                    <p className="stepVdo-text">Open the car's front bonnet.</p>
                  </li>
                  <li className="stepVdo">
                    <div className="stepVdo-number">3</div>
                    <p className="stepVdo-text">Close (roll-up) all the windows.</p>
                  </li>
                  <li className="stepVdo">
                    <div className="stepVdo-number">4</div>
                    <p className="stepVdo-text">Sit on the driver's seat.</p>
                  </li>
                  <li className="stepVdo">
                    <div className="stepVdo-number">5</div>
                    <p className="stepVdo-text">Start recording, focus on the RPM gauge</p>
                  </li>
                </ul>
              </div>

              <div className="instructions-column second">
                <ul className="stepVdo-list second"> 
                  <li className="stepVdo">
                    <div className="stepVdo-number">6</div>
                    <p className="stepVdo-text">
                      Turn on the ignition and keep the camera on the RPM for 5-10 sec
                    </p>
                  </li>
                  <li className="stepVdo">
                    <div className="stepVdo-number">7</div>
                    <p className="stepVdo-text">Exit the vehicle, continuing to record</p>
                  </li>
                  <li className="stepVdo">
                    <div className="stepVdo-number">8</div>
                    <p className="stepVdo-text">Capture a 360-degree view by walking around the car for 1 minute.</p>
                  </li>
                </ul> 
                <span><button className="skip-button" onClick={() => navigate(`/video/${claimNumber}`)}>
              Proceed
            </button></span>
              </div>
              
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoInstruction;